import "./SudokuCell.css";
import { useEffect } from "react";

export function SudokuCell({
    posX = 0,
    posY = 0,
    value = null,
    possibleDigits = [],
    selectedDigit = null,
    autoSolve = false,
    onDigitChange = () => {},
    onClear = () => {},
    onSelect = () => {},
}) {
    useEffect(() => {
        if (autoSolve && possibleDigits.length === 1 && value === null) {
            onDigitChange(posX, posY, possibleDigits[0]);
        }
    }, [possibleDigits, posX, posY, onDigitChange]);

    if (value !== null) {
        return (
            <div
                className="sudoku-cell"
                style={{ backgroundColor: selectedDigit !== null ? "#f8c3c0" : "white" }}
            >
                <span onClick={() => onSelect(value)}>{value}</span>
                <button onClick={() => onClear(posX, posY)}>X</button>
            </div>
        );
    }

    return (
        <div
            className="sudoku-cell"
            style={{
                backgroundColor:
                    selectedDigit !== null
                        ? possibleDigits.includes(selectedDigit)
                            ? "#c0f8de"
                            : "#f8c3c0"
                        : "white",
            }}
        >
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((digit) => {
                const isPossible = possibleDigits.includes(digit);
                return (
                    <div className="sudoku-cell-suggestion" key={digit}>
                        <span
                            className={isPossible ? "highlight" : "lowlight"}
                            onClick={() => isPossible && onDigitChange(posX, posY, digit, true)}
                        >
                            {digit}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}
